var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page--padding layout-category"},[_c('category-header',{attrs:{"items":_vm.categoriesInCity}}),_c('div',{staticClass:"layout-category__transition",class:_vm.routeClass},[_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }